import { createFileRoute, redirect } from "@tanstack/react-router";
import { isDesktopApp } from "@/lib/edition/is-desktop";
import { isLocalInstallEdition } from "@/lib/edition/edition";

// La lista de espera se cerró: el registro es abierto. Los enlaces viejos a
// /waitlist (correos, redes, `?ref=`) llevan al registro. Desktop e
// instalaciones locales no tienen registro: van al inicio de sesión.
export const Route = createFileRoute("/_home/waitlist")({
  beforeLoad: () => {
    if (isDesktopApp() || isLocalInstallEdition()) {
      throw redirect({ to: "/auth/sign-in" });
    }
    throw redirect({ to: "/auth/sign-up", replace: true });
  },
});
